<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Cài đặt mật khẩu google app</h1>
      <div class="btn-group float-right">
        <button type="button" class="btn font-medium btn-outline-secondary" @click="changePassword">
          <i class="bx bx-save"></i> Cập nhật
        </button>
      </div>
    </div>

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <ValidationObserver ref="addWarehouse" class="card-body px-20 mt-2 row">
        <form class="col-md-6">
          <ValidationProvider rules="required|minMaxName_2" vid="email" name="Email">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label">Email</label>
              <div class="col-sm-7">
                <input disabled v-model.trim="dataAdd.email" type="text" class="form-control" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required|minMaxName_5" vid="password" name="Mật khẩu">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label"
                >Mật khẩu <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <div class="input-group">
                  <input
                    v-model.trim="dataAdd.password"
                    :type="showPassword ? 'text' : 'password'"
                    class="form-control"
                    :placeholder="passwordPlaceholder"
                    @focus="onPasswordFocus"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      :disabled="!canTogglePassword"
                      @click="toggleShowPassword"
                    >
                      <i :class="showPassword ? 'bx bx-hide' : 'bx bx-show'"></i>
                    </button>
                  </div>
                </div>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
        </form>
      </ValidationObserver>
    </div>

    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { CommonService } from '@/services/common.service'

  export default {
    data() {
      return {
        dataAdd: {},
        showPassword: false,
        isEditingPassword: false,
        originalPassword: '',
        loading: false,
      }
    },

    computed: {
      passwordPlaceholder() {
        if (this.isEditingPassword) {
          return 'Nhập mật khẩu mới'
        }
        return ''
      },

      canTogglePassword() {
        // Chỉ cho phép toggle khi đang chỉnh sửa mật khẩu
        return this.isEditingPassword
      },
    },

    created() {
      this.getInfroGoogleApp()
    },

    methods: {
      onPasswordFocus() {
        if (!this.isEditingPassword) {
          this.isEditingPassword = true
          this.dataAdd.password = ''
          this.showPassword = false
        }
      },

      toggleShowPassword() {
        if (this.canTogglePassword) {
          this.showPassword = !this.showPassword
        }
      },

      async getInfroGoogleApp() {
        this.loading = true
        try {
          const res = await CommonService.getInfroGoogleApp(this.dataAdd)
          if (res.code === 1000) {
            this.dataAdd = res.data || {}
            // Lưu mật khẩu gốc
            if (this.dataAdd.password) {
              this.originalPassword = this.dataAdd.password
            }
            this.isEditingPassword = false
          } else {
            this.showFailMx(res.message || 'Đã có lỗi không xác định xảy ra')
          }
        } catch (error) {
          this.showFailMx(error.message || 'Đã có lỗi không xác định xảy ra')
        } finally {
          this.loading = false
        }
      },

      async changePassword() {
        this.loading = true
        try {
          // Nếu đang chỉnh sửa nhưng mật khẩu không thay đổi thì báo lỗi
          if (
            this.isEditingPassword &&
            (!this.dataAdd.password || this.dataAdd.password === this.originalPassword)
          ) {
            this.showFailMx('Bạn chưa nhập mật khẩu mới hoặc mật khẩu mới trùng với mật khẩu cũ')
            this.loading = false
            return
          }

          // Nếu không đang chỉnh sửa thì sử dụng mật khẩu gốc
          const passwordToSend =
            this.isEditingPassword && this.dataAdd.password
              ? this.dataAdd.password
              : this.originalPassword

          const res = await CommonService.changePasswordGoogleApp({ password: passwordToSend })
          if (res.code === 1000) {
            this.showSuccessMx(res.message || 'Cập nhật mật khẩu thành công')
            // Cập nhật mật khẩu gốc sau khi thành công
            if (this.isEditingPassword && this.dataAdd.password) {
              this.originalPassword = this.dataAdd.password
            }
            // Reset trạng thái
            this.isEditingPassword = false
            this.showPassword = false
          } else {
            this.showFailMx(res.message || 'Đã có lỗi không xác định xảy ra')
          }
        } catch (error) {
          this.showFailMx(error.message || 'Đã có lỗi không xác định xảy ra')
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style scoped>
  .input-group-append .btn {
    border-left: 0;
  }

  .input-group-append .btn:focus {
    box-shadow: none;
  }

  .input-group-append .btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
</style>
